<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          v-model="classId"
          clearable
          filterable
          class="w-200px ml-10px"
          placeholder="解析实体"
          size="small"
        >
          <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="modelName"
          clearable
          class="w-200px ml-10px mr-10px"
          placeholder="模型名称"
          size="small"
        ></el-input>
        <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
        <el-button type="primary" :disabled="!$hasAccess('create')" @click="addTask">{{
          $t('new')
        }}</el-button>
        <el-button type="danger" :disabled="!$hasAccess('delete')" @click="delTask(idList)">{{
          $t('delete')
        }}</el-button>
        <!-- <el-button :disabled="!$hasAccess('export')">{{ $t('export') }}</el-button>
        <el-button :disabled="!$hasAccess('import')">{{ $t('import') }}</el-button> -->
      </el-row>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        border
        class="mt-20px"
        height="calc(100% - 104px)"
        :highlight-current-row="true"
        @selection-change="selectionChange"
        @sort-change="sortChange"
        stripe
        ref="table"
        row-key="id"
      >
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="standardName"
          label="标准名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="className" label="解析实体" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="classAttributeName"
          label="解析字段"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="classAttributeValue"
          label="属性值"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="modelName" label="模型名称" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="modelFileName"
          label="模型文件名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="sourceName" label="数据来源" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <div>
              <el-button size="mini" @click="delTask([scope.row.id])">{{ $t('delete') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-20px float-right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新建 -->
    <el-dialog
      title="新建关联"
      :visible.sync="addVisiable"
      class="small-dialog"
      :close-on-click-modal="false"
      v-dialogDrag
      @close="closeBaseFormDialog"
    >
      <el-form ref="baseForm" label-width="150px" :model="form" :rules="rules">
        <el-form-item label="标准名称" prop="standardId">
          <el-select
            v-model="form.standardId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择标准"
            size="small"
            @change="changeStandardId"
          >
            <el-option
              v-for="item in standardList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解析实体" prop="classId">
          <el-select
            v-model="form.classId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择实体"
            size="small"
            @change="changeClassId"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解析字段" prop="classAttributeId">
          <el-select
            v-model="form.classAttributeId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择属性"
            size="small"
            @change="changeClassAttributeId"
          >
            <el-option
              v-for="item in attributeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性值" prop="dataId">
          <el-input
            v-model="form.dataName"
            :placeholder="`${$t('pleaseSelect')}`"
            clearable
            class="w-full can-not-input"
            @clear="clearAttribute"
          >
            <el-button
              slot="append"
              icon="iconfont icon-line-seach"
              @click="showAttributeDialog"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="模型名称" prop="modelName">
          <el-input
            v-model="form.modelName"
            :placeholder="`${$t('pleaseSelect')}`"
            clearable
            class="w-full can-not-input"
            @clear="clearModelName"
          >
            <el-button
              slot="append"
              icon="iconfont icon-line-seach"
              @click="modelVisiable = true"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeBaseFormDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" @click="submitBaseForm">{{ `${$t('save')}` }}</el-button>
      </div>
    </el-dialog>

    <!-- 选择模型 -->
    <selectModel
      :modelVisiable="modelVisiable"
      @updateModelData="updateModelData"
      @closeModelDialog="closeModelDialog"
      type="relation"
    />
    <!-- 选择属性值 -->
    <selectAttributeValues
      :attributeValuesVisiable="attributeValuesVisiable"
      :classId="form.classId"
      :classAttributeId="form.classAttributeId"
      :attributeCode="attributeCode"
      @closeAttributeDialog="closeAttributeDialog"
      @updateAttributeValue="updateAttributeValue"
    />
  </div>
</template>

<script>
import assetService from '@/services/assetService'
import ModelParsingTaskService from '@/services/ModelParsingTaskService'
import stdClassListService from '@/services/stdClassListService'
import selectStandardId from '../../components/selectStandardId'
import selectModel from './components/selectModel'
import selectAttributeValues from './components/selectAttributeValues'

export default {
  name: 'Affiliations',
  components: { selectStandardId, selectModel, selectAttributeValues },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      standardList: [],
      classTypeList: [],
      classId: '',
      modelName: '',
      tableData: [],
      tableLoading: false,
      selectionList: [],
      idList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      addVisiable: false,
      form: {
        modelName: '',
        modelId: '',
        modelFileId: '',
        standardId: '',
        classId: '',
        classAttributeId: '',
        dataId: '',
        dataName: '',
      },
      rules: {
        modelName: [{ required: true, message: '请选择模型名称', trigger: 'blur' }],
        standardId: [{ required: true, message: '请选择标准', trigger: 'blur' }],
        classAttributeId: [{ required: true, message: '请选择属性', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择实体', trigger: 'blur' }],
        dataId: [{ required: true, message: '请选择属性值', trigger: 'blur' }],
      },
      modelVisiable: false,
      classList: [],
      attributeList: [],
      attributeValuesVisiable: false,
      attributeCode: '',
    }
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.getClassTypeList()
        this.searchTableData()
      }
    },
    classId() {
      this.searchTableData()
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    // 获取实体列表
    async getClassTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        standard_id: this.form.standardId,
        data_type: 1,
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    // 获取属性列表
    async getAttrList() {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId: this.form.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data
      }
    },
    selectionChange(val) {
      this.selectionList = val
      this.idList = _.map(val, (item) => {
        return item.id
      })
    },
    sortChange() {},
    delTask(ids) {
      if (ids.length > 0) {
        this.$confirm('是否确定要删除该模型关联关系, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await ModelParsingTaskService.deleteModelObjectRelation(ids)
          if (res) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.info('请选择要删除的数据')
      }
    },
    addTask() {
      this.addVisiable = true
      this.standardList = localStorage.getItem('standardList')
        ? JSON.parse(localStorage.getItem('standardList'))
        : ''
      this.form.standardId = this.standardId
      this.changeStandardId()
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.searchTableData()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.searchTableData()
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await ModelParsingTaskService.getModelObjectRelationList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        standardId: this.standardId,
        classId: this.classId,
        modelName: this.modelName,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
    },
    clearModelName() {
      this.form.modelName = ''
      this.form.modelId = ''
    },
    clearAttribute() {
      this.form.dataName = ''
      this.form.dataId = ''
    },
    closeBaseFormDialog() {
      this.$refs.baseForm.resetFields()
      this.form = this.$options.data().form
      this.addVisiable = false
    },
    submitBaseForm() {
      this.$refs.baseForm.validate(async (valid) => {
        if (valid) {
          const res = await ModelParsingTaskService.addModelObjectRelation(this.form)
          if (res && res.code === 0) {
            this.$message.success('新增成功')
            this.searchTableData()
            this.closeBaseFormDialog()
          }
        }
      })
    },
    updateModelData(data) {
      this.form.modelName = data[0].name
      this.form.modelId = data[0].id
      this.form.modelFileId = _.find(data[0].medias, { mediaType: 1 }).fileInfoId
    },
    closeModelDialog() {
      this.modelVisiable = false
    },
    selectObject(val) {
      this.form.attributeId = val.id
      this.form.attributeName = val.name
    },
    closeAttributeDialog() {
      this.attributeValuesVisiable = false
    },
    showAttributeDialog() {
      if (this.form.classAttributeId === '' || this.form.classAttributeId === null) {
        this.$message.info('请先选择属性')
        return
      }
      this.attributeValuesVisiable = true
    },
    changeStandardId() {
      this.form.classId = ''
      this.form.classAttributeId = ''
      this.form.dataId = ''
      this.form.dataName = ''
      this.getClassList()
    },
    changeClassId() {
      this.form.classAttributeId = ''
      this.form.dataId = ''
      this.form.dataName = ''
      this.getAttrList()
    },
    updateAttributeValue(val) {
      this.form.dataId = val.id
      this.form.dataName = val[this.attributeCode]
    },
    changeClassAttributeId(val) {
      if (val) {
        _.map(this.attributeList, (item) => {
          if (val === item.id) {
            this.attributeCode = item.code
          }
        })
      }
      this.clearAttribute()
    },
  },
  created() {
    this.getClassTypeList()
    this.searchTableData()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}

</style>
